"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
import React from "react";
import { observer } from "mobx-react";
import { getAvatarColorByName } from "./AvatarColor";
import { User, IconSize, Team, Account, Add } from "../../icons";
import { Label } from "../Label";
import classNames from "classnames";
export var AvatarSize = /* @__PURE__ */ ((AvatarSize2) => {
  AvatarSize2["Small"] = "small";
  AvatarSize2["Large"] = "large";
  return AvatarSize2;
})(AvatarSize || {});
export var AvatarType = /* @__PURE__ */ ((AvatarType2) => {
  AvatarType2["User"] = "user";
  AvatarType2["Team"] = "team";
  AvatarType2["Account"] = "account";
  return AvatarType2;
})(AvatarType || {});
let Avatar = class extends React.Component {
  constructor(props) {
    super(props);
    this.getAvatarColor = () => {
      const { lastName, firstName } = this.props;
      return getAvatarColorByName((firstName != null ? firstName : "") + (lastName != null ? lastName : ""));
    };
    this.renderInnerAvatar = () => {
      if (!!this.props.firstName) {
        return this.renderWithInitials();
      } else {
        return this.renderAvatarIcon();
      }
    };
    this.renderWithInitials = () => {
      const { firstName, lastName, size, image } = this.props;
      const avatarLabelSize = size === "large" /* Large */ ? "m" : "s";
      return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Label, { size: avatarLabelSize, "aria-label": `${firstName != null ? firstName : ""} ${lastName != null ? lastName : ""}` }, this.getInitials(firstName, lastName)), !!image && /* @__PURE__ */ React.createElement("img", { className: "avatar__image", alt: "", role: "presentation", src: image }));
    };
    this.renderAvatarIcon = () => {
      const { type, size } = this.props;
      const avatarIconSize = size === "large" /* Large */ ? IconSize.Medium : IconSize.Small;
      if (type === "user" /* User */) {
        return /* @__PURE__ */ React.createElement(User, { size: avatarIconSize });
      }
      if (type === "team" /* Team */) {
        return /* @__PURE__ */ React.createElement(Team, { size: avatarIconSize });
      }
      if (type === "account" /* Account */) {
        return /* @__PURE__ */ React.createElement(Account, { size: IconSize.Medium });
      }
    };
    const { lastName, firstName } = props;
    if (lastName && !firstName) {
      throw new Error("Avatar was given a last name but no first name");
    }
  }
  render() {
    const { size, type, isInvite, className } = this.props;
    const AvatarColor = this.getAvatarColor();
    return /* @__PURE__ */ React.createElement(
      "div",
      {
        style: { backgroundColor: AvatarColor },
        className: classNames(`avatar avatar--${size} avatar--${type}`, className)
      },
      this.renderInnerAvatar(),
      isInvite && /* @__PURE__ */ React.createElement("div", { className: "avatar__invite" }, /* @__PURE__ */ React.createElement(Add, null))
    );
  }
  getInitials(first, last) {
    if (last != null && last.length > 0) {
      return `${first[0]}${last[0]}`.toUpperCase();
    } else {
      return first[0].toUpperCase();
    }
  }
};
Avatar.defaultProps = {
  size: "small" /* Small */,
  type: "user" /* User */
};
Avatar = __decorateClass([
  observer
], Avatar);
export {
  Avatar as default
};
